// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCxU5P0XmqyU1N2uEOIixmzhp_hXbq9U8E",
  authDomain: "bd-train-tracker-bf870.firebaseapp.com",
  databaseURL: "https://bd-train-tracker-bf870-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "bd-train-tracker-bf870",
  storageBucket: "bd-train-tracker-bf870.firebasestorage.app",
  messagingSenderId: "733247386780",
  appId: "1:733247386780:web:1abac10d5944017a2ba959",
  measurementId: "G-FR876FR8JS"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export default app;
